import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  // Sidebar state
  sidebarPinned: boolean;
  sidebarOpen: boolean;

  // Theme state
  themeMode: 'light' | 'dark';

  // Actions
  setSidebarPinned: (pinned: boolean) => void;
  setSidebarOpen: (open: boolean) => void;
  toggleTheme: () => void;
  setThemeMode: (mode: 'light' | 'dark') => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Initial state
      sidebarPinned: false,
      sidebarOpen: false,
      themeMode: 'light',

      // Actions
      setSidebarPinned: (pinned) => set({ sidebarPinned: pinned }),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleTheme: () =>
        set((state) => ({
          themeMode: state.themeMode === 'light' ? 'dark' : 'light',
        })),
      setThemeMode: (mode) => set({ themeMode: mode }),
    }),
    {
      name: 'linga-ai-ui-store',
      partialize: (state) => ({
        sidebarPinned: state.sidebarPinned,
        themeMode: state.themeMode,
      }),
    }
  )
);
